<!-- eslint-disable -->
<template>
  <CommonPages id="about" classs="about-page" titlePrefix="About Us - Velocifyx"
    metaDescription="Connect with the right audience through our seamless, transparent ad trading platform. Access premium inventory, optimize campaigns in real time, and leverage expert support to drive measurable growth for your brand.">
    <div class="page-header"></div>
    <section class="about-story-section">
      <div class="about-story-section__content">
        <h1 class="about-story-section__title">Our story</h1>
        <p class="about-story-section__description">
          Founded by advertising industry experts, we are committed to simplifying ad trading through innovative technology and personalized support, helping brands achieve measurable growth.
        </p>
      </div>
      <div class="about-story-section__image-container">
        <img src="@/assets/story-1.png" alt="Our story" class="about-story-section__image">
      </div>
    </section>
    <section class="about-connect-section">
      <div class="about-connect-section__image-container">
        <img src="@/assets/story-2.png" alt="Connecting advertisers"
          class="about-connect-section__image">
      </div>
      <div class="about-connect-section__content">
        <h2 class="about-connect-section__title">Seamless Advertising, Measurable Growth</h2>
        <p class="about-connect-section__description">
          For years, we’ve empowered hundreds of clients worldwide to efficiently buy and sell advertising inventory, delivering measurable growth. Driven by innovation and a commitment to excellence, we continuously adapt to the evolving needs of the digital advertising ecosystem.
        </p>
      </div>
    </section>
  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue';
import '@/css/about.scss';

export default {
  name: 'About',
  components: {
    CommonPages,
  },
};
</script>
